<template>
  <div>
    <el-dialog
      :visible.sync="demorado"
      width="300px"
      :top="'3vh'"
   
      :center="true"
      custom-class="modal-inner1"
      :lock-scroll="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :destroy-on-close="false"
    >
      <p style="font-size: 16px; text-align: center">
        Estamos recopilando información de tu pedido
      </p>
      <div
        style="margin-top: 10px; height: 100px; font-size: 40px"
        element-loading-spinner="el-icon-loading"
        v-loading="recopilando"
      ></div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { EventBus } from "@/event-bus";
export default {
  data() {
    return {
      demorado: false,
      recopilando: true,
    };
  },
  created() {
    EventBus.$on("verFormDemorado", (d) => {
      this.demorado = true;
      this.cancelar(d)
    });
    //   EventBus.$on('enviarFormCancelar', (m) => {
    //       this.cancelar(m)
    //   })
  },
  computed: {
    ...mapGetters(["pedidoCancelado", "messages"]),
  },
  methods: {
    verForm() {
      EventBus.$emit("openForm", true);
    },
    ...mapActions({
      vuexCancelarPedido: "cancelarPedido",
      vuexIniciarReclamoLocal: "iniciarReclamoLocal",
      vuexGuardarMensaje: "guardarMensaje",
      vuexCargando: "isLoading",
      vuexCrearCasoWebCentrix: "crearCasoWebCentrix",
    }),
    async cancelar(m) {
         // datosWc.content = `Hola, me comunico para informarles que mi pedido esta demorado.`
          // datosWc.priority= 'high'
          // datosWc.status  = 'open'
          // datosWc.tags    = ['Seguimiento']         
          // this.vuexCrearCasoWebCentrix({datosWc, motivoIngresado})
      let datosWc = {
        content: `Hola, me comunico para informarles que mi pedido esta demorado.`,
        dni: this.$store.state.datos["dni"],
        email: this.$store.state.datos["mail_d"]
          ? this.$store.state.datos["mail_d"]
          : "",
        fechaVtex: this.$date(this.$store.state.datos.vtex_fecha.date).format(
          "DD/MM/YYYY HH:mm"
        ),
        motivoId: m.id,
        nombre: this.$store.state.datos["nombre"],
        envio: this.$store.state.datos["envio"],
        status: "open",
        tags: ["Seguimiento"],
       telefono: this.$store.state.datos["telefono"],
        totalOperacion: this.$store.state.datos.importe / 100,
        vtex_id: this.$store.state.datos.vtex_id,
        wcTipo: m.wc_tipo,
        priority: "high",
        motivo_id: m.id,
      };
      // this.vuexCrearCasoWebCentrix({ datosWc, motivoIngresado: m });
      let result = this.vuexCancelarPedido({ datosWc, motivoIngresado: m });
      result.then((res) => {
        console.log("vuexCancelarPedido", res);
        // this.recopilando = false
        // EventBus.$emit("procesarArrepentimiento", true);
      });
    },

    regresarMobile() {
      EventBus.$emit("isMobile", false);
      EventBus.$emit("cerrarDemorado", false);
    },
    regresar() {
      EventBus.$emit("cerrarDemorado", false);
    },
  },
};
</script>


<style  >
.modal-inner1 > .el-dialog__header {
  display: none;
  
}
.modal-inner1{
 border-radius: 20px;
  font-size   : 16px;
}
</style>